export const darkTheme = {
  bg:"#181818",
  bgLighter:"#202020",
  text:"white",
  textSoft:"#aaaaaa",
  soft:"#373737"
}
export const lightTheme = {
  bg:"#d7d7d7",
  bgLighter:"#ededed",
  text:"black",
  textSoft:"#606060",
  soft:"rgb(161 161 161)"
}